import React from 'react'

import { Content } from 'sdk/components/content/Content'
import { Text, TextName } from 'sdk/text/Text'
import { Button } from 'sdk/button/Button'
import { CodeSnippet } from 'sdk/components/code-snippet/CodeSnippet'

import classes from './style.module.scss'

interface CodeBlockWithTitleProps {
  heading: string
  body: string
  code: string
  button?: {
    text: string
    to: string
  }
}

export const CodeBlockWithTitle: React.FC<CodeBlockWithTitleProps> = ({
  heading,
  body,
  code,
  button,
}) => {
  return (
    <Content>
      <div className={classes.container}>
        <div className={classes.leftContent}>
          <Text type={TextName.H2} className={classes.heading}>
            {heading}
          </Text>
          <Text type={TextName.Text} className={classes.body}>
            {body}
          </Text>
          {button && (
            <Button
              as="router-link"
              to={button.to}
              className={classes.button}
            >
              {button.text}
            </Button>
          )}
        </div>
        <div className={classes.codeContainer}>
          <CodeSnippet code={code} highlight />
        </div>
      </div>
    </Content>
  )
}
